import { Component } from '@angular/core';
import { Products } from './../../../models/product.model';
import { Paginator } from './../../../models/paginator.model';
import { Router } from '@angular/router';
import { ProductService } from '../../../shared/services/products/product.service';
import { GridService } from '../../../shared/services/utils/grid.service';
import { ProductShowComponent } from './product-show/product-show.component';
import { RoundedPaginationComponent } from '../../../shared/components/rounded-pagination/rounded-pagination.component';
import { SeoService } from '../../../shared/services/seo.service';

@Component({
  selector: 'app-product',
  imports: [ProductShowComponent,RoundedPaginationComponent],
  templateUrl: './product.component.html',
  styleUrl: './product.component.scss'
})
export class ProductComponent {

  public listView: boolean = false;
  
  public productList: [Products];
  public paginator: Paginator;
  public searchValue: string;
  public pageNumbers: number[] = [];
  constructor( public gridServices : GridService,
    private _router:Router,
    private _productService:ProductService,
    private seo: SeoService         
    ){
    /**
 * Sets up SEO meta tags using SeoService
 * This helps in optimizing the page for search engines and social media previews.
*/
    this.seo.setTags({
      title: 'Home Page Product component', // Title
      titleSuffix: '- Shining On Safety', // Title Suffix
      description: 'Shining On Safety', // Description
      image: '', // Image
      keywords: 'Shining On Safety' // Keywords
    });
     }

  ngOnInit(): void {
    this.findProducts({value:""});

    this._productService.filter("",undefined,undefined,8).subscribe({
      next: (response) => {
        this.productList=response.data;
        this.paginator=response.paginator;
      },
      error: ({error}) => {
      },
    })

    
  }

  gridOpens() {
    this.listView = false;
    this.gridServices.gridOpen()
  }

  listOpens() {
    this.listView = true;
    this.gridServices.listOpen()
  }

  grid2s() {
    this.listView = false;
    this.gridServices.grid2()
  }

  grid3s() {
    this.listView = false;
    this.gridServices.grid3()
  }

  grid6s() {
    this.listView = false;
    this.gridServices.grid6()
  }

  findProducts({value}:any){
    if (value.length<3 && value.length!=0) {
      return;
    }
    this._productService.filter(value,undefined,undefined,8).subscribe({
      next: (response) => {
        this.productList=response.data;
        this.searchValue=value;
        this.paginator=response.paginator;
      },
      error: ({error}) => {
      },
    })
  }

  paginatorFind(){
    this._productService.filter(this.searchValue,undefined,this.paginator.page,8).subscribe({
      next: (response) => {
        this.productList=response.data;
        this.paginator=response.paginator;
      },
      error: ({error}) => {
      },
    })
  }

  redirectToSearch({value}:any){
    window.scrollTo(0, 0);
    this._router.navigate(["/search"],{ queryParams: { search: value } })
  }

}
